import React from 'react';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import './style.scss';

const NeedFurtherHelp = (props) => (
  <div className="FurtherHelpContainer">
    <div className="CardContainer">
      <div className="top__Side">
        <span className="title">
          <Text field={props?.fields?.Title} />
        </span>
        <span className="subTitle">
          <Text field={props?.fields?.Subtitle} />
        </span>
      </div>
      <div className="bottom__side">
        <div className="left__side">
          <span className="info__title">
            <Text field={props?.fields?.LocalContactNumberText} />
          </span>
          <span className="info__desc">
            <Text field={props?.fields?.LocalContactNumber} />
          </span>
        </div>
        <div className="right__side">
          <span className="info__title">
            <Text field={props?.fields?.InternationalContactNumberText} />
          </span>
          <span className="info__desc">
            <Text field={props?.fields?.InternationalContactNumber} />
          </span>
        </div>
      </div>
    </div>
  </div>
);

export default NeedFurtherHelp;
